/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import type {
  PaginatedViolationListList,
  PatchedViolationCreateUpdateRequestRequest,
  ViolationCreateUpdate,
  ViolationCreateUpdateRequestRequest,
  ViolationDetail,
  ViolationList,
  ViolationResolveRequest,
  ViolationsListParams
} from '../../model';

import { customFetch } from '../../../liftApiMutator';

export type violationsListResponse200 = {
  data: PaginatedViolationListList
  status: 200
}

export type violationsListResponseSuccess = (violationsListResponse200) & {
  headers: Headers;
};
;

export type violationsListResponse = (violationsListResponseSuccess)

export const getViolationsListUrl = (params?: ViolationsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["portfolio","region","service_provider"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/violations/?${stringifiedParams}` : `/api/v1/violations/`
}

/**
 * Optimized list view with minimal metadata calculation
 */
export const violationsList = async (params?: ViolationsListParams, options?: RequestInit): Promise<violationsListResponse> => {

  return customFetch<violationsListResponse>(getViolationsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type violationsCreateResponse201 = {
  data: ViolationCreateUpdate
  status: 201
}

export type violationsCreateResponseSuccess = (violationsCreateResponse201) & {
  headers: Headers;
};
;

export type violationsCreateResponse = (violationsCreateResponseSuccess)

export const getViolationsCreateUrl = () => {




  return `/api/v1/violations/`
}

/**
 * ViewSet for managing violations
 */
export const violationsCreate = async (violationCreateUpdateRequestRequest: ViolationCreateUpdateRequestRequest, options?: RequestInit): Promise<violationsCreateResponse> => {

  return customFetch<violationsCreateResponse>(getViolationsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(violationCreateUpdateRequestRequest)
  }
);}


export type violationsRetrieveResponse200 = {
  data: ViolationDetail
  status: 200
}

export type violationsRetrieveResponseSuccess = (violationsRetrieveResponse200) & {
  headers: Headers;
};
;

export type violationsRetrieveResponse = (violationsRetrieveResponseSuccess)

export const getViolationsRetrieveUrl = (id: string,) => {




  return `/api/v1/violations/${id}/`
}

/**
 * ViewSet for managing violations
 */
export const violationsRetrieve = async (id: string, options?: RequestInit): Promise<violationsRetrieveResponse> => {

  return customFetch<violationsRetrieveResponse>(getViolationsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}


export type violationsUpdateResponse200 = {
  data: ViolationCreateUpdate
  status: 200
}

export type violationsUpdateResponseSuccess = (violationsUpdateResponse200) & {
  headers: Headers;
};
;

export type violationsUpdateResponse = (violationsUpdateResponseSuccess)

export const getViolationsUpdateUrl = (id: string,) => {




  return `/api/v1/violations/${id}/`
}

/**
 * ViewSet for managing violations
 */
export const violationsUpdate = async (id: string,
    violationCreateUpdateRequestRequest: ViolationCreateUpdateRequestRequest, options?: RequestInit): Promise<violationsUpdateResponse> => {

  return customFetch<violationsUpdateResponse>(getViolationsUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(violationCreateUpdateRequestRequest)
  }
);}


export type violationsPartialUpdateResponse200 = {
  data: ViolationCreateUpdate
  status: 200
}

export type violationsPartialUpdateResponseSuccess = (violationsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type violationsPartialUpdateResponse = (violationsPartialUpdateResponseSuccess)

export const getViolationsPartialUpdateUrl = (id: string,) => {




  return `/api/v1/violations/${id}/`
}

/**
 * ViewSet for managing violations
 */
export const violationsPartialUpdate = async (id: string,
    patchedViolationCreateUpdateRequestRequest?: PatchedViolationCreateUpdateRequestRequest, options?: RequestInit): Promise<violationsPartialUpdateResponse> => {

  return customFetch<violationsPartialUpdateResponse>(getViolationsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedViolationCreateUpdateRequestRequest)
  }
);}


export type violationsDestroyResponse204 = {
  data: void
  status: 204
}

export type violationsDestroyResponseSuccess = (violationsDestroyResponse204) & {
  headers: Headers;
};
;

export type violationsDestroyResponse = (violationsDestroyResponseSuccess)

export const getViolationsDestroyUrl = (id: string,) => {




  return `/api/v1/violations/${id}/`
}

/**
 * ViewSet for managing violations
 */
export const violationsDestroy = async (id: string, options?: RequestInit): Promise<violationsDestroyResponse> => {

  return customFetch<violationsDestroyResponse>(getViolationsDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}


export type violationsHistoryRetrieveResponse200 = {
  data: ViolationList
  status: 200
}

export type violationsHistoryRetrieveResponseSuccess = (violationsHistoryRetrieveResponse200) & {
  headers: Headers;
};
;

export type violationsHistoryRetrieveResponse = (violationsHistoryRetrieveResponseSuccess)

export const getViolationsHistoryRetrieveUrl = (id: string,) => {




  return `/api/v1/violations/${id}/history/`
}

/**
 * Get detailed history for a specific violation
 */
export const violationsHistoryRetrieve = async (id: string, options?: RequestInit): Promise<violationsHistoryRetrieveResponse> => {

  return customFetch<violationsHistoryRetrieveResponse>(getViolationsHistoryRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}


export type violationsResolveCreateResponse200 = {
  data: ViolationDetail
  status: 200
}

export type violationsResolveCreateResponseSuccess = (violationsResolveCreateResponse200) & {
  headers: Headers;
};
;

export type violationsResolveCreateResponse = (violationsResolveCreateResponseSuccess)

export const getViolationsResolveCreateUrl = (id: string,) => {




  return `/api/v1/violations/${id}/resolve/`
}

/**
 * Resolve a violation with a specific resolution type
 */
export const violationsResolveCreate = async (id: string,
    violationResolveRequest: ViolationResolveRequest, options?: RequestInit): Promise<violationsResolveCreateResponse> => {

  return customFetch<violationsResolveCreateResponse>(getViolationsResolveCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(violationResolveRequest)
  }
);}


export type violationsStatisticsRetrieveResponse200 = {
  data: ViolationList
  status: 200
}

export type violationsStatisticsRetrieveResponseSuccess = (violationsStatisticsRetrieveResponse200) & {
  headers: Headers;
};
;

export type violationsStatisticsRetrieveResponse = (violationsStatisticsRetrieveResponseSuccess)

export const getViolationsStatisticsRetrieveUrl = () => {




  return `/api/v1/violations/statistics/`
}

/**
 * Get detailed violation statistics
 */
export const violationsStatisticsRetrieve = async ( options?: RequestInit): Promise<violationsStatisticsRetrieveResponse> => {

  return customFetch<violationsStatisticsRetrieveResponse>(getViolationsStatisticsRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}


